export default Object.freeze({
  ListSortCriteria: {
    Text: 0,
    Value: 1
  }
});
